import classNames from 'classnames';
import React, { FC } from 'react';

import { ButtonDeprecated, ButtonDeprecatedProps } from '../ButtonDeprecated';
import { IconDeprecated } from '../IconDeprecated';

import { IconTypeDeprecated } from '../IconDeprecated/types';

import { append } from '../../../utils';

import styles from './IconButtonDeprecated.module.css';

export interface IconButtonDeprecatedProps extends ButtonDeprecatedProps {
  onClick: () => void;
  name?: IconTypeDeprecated;
}

export const IconButtonDeprecated: FC<IconButtonDeprecatedProps> = ({
  className,
  onClick,
  testId,
  name,
  isInverted,
  ...restProps
}) => (
  <ButtonDeprecated
    className={classNames(className, styles.IconButton, {
      [styles.inverted]: isInverted,
    })}
    variant="text"
    type="button"
    onClick={onClick}
    testId={testId}
    {...restProps}
  >
    <IconDeprecated
      name={name}
      isInverted={isInverted}
      testId={append(testId, 'icon')}
    />
  </ButtonDeprecated>
);
